import React, { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";

export const Counter = ({ value, suffix = "", duration = 1.6 }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });
  const [n, setN] = useState(0);

  useEffect(() => {
    if (!inView) return;
    let raf;
    const start = performance.now();
    const target = value;
    const step = (t) => {
      const progress = Math.min((t - start) / (duration * 1000), 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setN(Math.floor(eased * target));
      if (progress < 1) raf = requestAnimationFrame(step);
      else setN(target);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [inView, value, duration]);

  return (
    <motion.span
      ref={ref}
      className="font-mono-tech text-4xl md:text-5xl font-semibold text-brand-blue tabular-nums"
    >
      {n}
      {suffix}
    </motion.span>
  );
};
